var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c("div", { staticClass: "m-subheader" }, [
      _c("div", { staticClass: "d-flex align-items-center" }, [
        _c("div", { staticClass: "mr-auto" }, [
          _c(
            "ul",
            { staticClass: "m-subheader__breadcrumbs m-nav m-nav--inline" },
            [
              _c(
                "li",
                { staticClass: "m-nav__item" },
                [
                  _c("router-link", { attrs: { to: { name: "home" } } }, [
                    _c("span", { staticClass: "m-nav__link-text" }, [
                      _c("i", { staticClass: "m-nav__link-icon la la-home" })
                    ])
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c("li", { staticClass: "m-nav__separator" }, [
                _vm._v("\n\t\t  \t  \t\t>\n\t\t  \t  \t")
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "m-nav__item" }, [
                _c("span", { staticClass: "m-nav__link-text" }, [
                  _vm._v(
                    "\n\t\t  \t  \t\t\t\t" +
                      _vm._s(
                        _vm._f("titleize")(
                          _vm._f("translate")("authorizations_administration")
                        )
                      ) +
                      "\n\t\t  \t  \t\t\t"
                  )
                ])
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "m-nav__separator" }, [
                _vm._v("\n\t\t  \t  \t\t>\n\t\t  \t  \t")
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "m-nav__item" }, [
                _c("span", { staticClass: "m-nav__link-text" }, [
                  _vm._v(
                    "\n\t\t  \t  \t\t\t" +
                      _vm._s(
                        _vm._f("titleize")(_vm._f("translate")("cargo_staff"))
                      ) +
                      "\n\t\t  \t  \t\t"
                  )
                ])
              ])
            ]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "m-content", attrs: { id: "content" } },
      [
        _c("div", { staticClass: "m-portlet m-portlet--mobile" }, [
          _c("div", { staticClass: "m-portlet__head" }, [
            _c("div", { staticClass: "m-portlet__head-caption" }, [
              _c("div", { staticClass: "m-portlet__head-title" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("h3", { staticClass: "m-portlet__head-text" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm._f("capitalize")(_vm._f("translate")("cargo_staff"))
                      ) +
                      "\n              "
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "m-portlet__head-tools" }, [
              _c("ul", { staticClass: "m-portlet__nav" }, [
                _c(
                  "li",
                  { staticClass: "m-portlet__nav-item" },
                  [
                    _vm.hide_create
                      ? _c(
                          "router-link",
                          {
                            staticClass: "btn btn-success m-btn m-btn--icon",
                            class: {
                              disabled: !_vm.allow_create_authorizations
                            },
                            attrs: {
                              to: { name: "createCargoStaff" },
                              "aria-disabled": !_vm.allow_create_authorizations
                            }
                          },
                          [
                            _c("span", [
                              _c("i", { staticClass: "fa fa-plus" }),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  "\n                      " +
                                    _vm._s(
                                      _vm._f("capitalize")(
                                        _vm._f("translate")("new_cargo_staff")
                                      )
                                    ) +
                                    "\n                    "
                                )
                              ])
                            ])
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "m-portlet__body" },
            [
              _c("div", { staticClass: "form-group m-form__group row" }, [
                _c("div", { staticClass: "col-lg-3" }, [
                  _c("label", { attrs: { for: "plate" } }, [
                    _vm._v(
                      _vm._s(_vm._f("capitalize")(_vm._f("translate")("plate")))
                    )
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.plate,
                        expression: "plate"
                      }
                    ],
                    staticClass: "form-control m-input",
                    attrs: { id: "plate", type: "text", name: "plate" },
                    domProps: { value: _vm.plate },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.plate = $event.target.value
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-lg-4" }, [
                  _c("label", { attrs: { for: "cargo_order" } }, [
                    _vm._v(
                      _vm._s(
                        _vm._f("capitalize")(_vm._f("translate")("cargo_order"))
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.cargo_order,
                        expression: "cargo_order"
                      }
                    ],
                    staticClass: "form-control m-input",
                    attrs: {
                      id: "cargo_order",
                      type: "text",
                      name: "cargo_order"
                    },
                    domProps: { value: _vm.cargo_order },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.cargo_order = $event.target.value
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-lg-4" }, [
                  _c("label", { attrs: { for: "departure_order" } }, [
                    _vm._v(
                      _vm._s(
                        _vm._f("capitalize")(
                          _vm._f("translate")("departure_order")
                        )
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.departure_order,
                        expression: "departure_order"
                      }
                    ],
                    staticClass: "form-control m-input",
                    attrs: {
                      id: "departure_order",
                      type: "text",
                      name: "departure_order"
                    },
                    domProps: { value: _vm.departure_order },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.departure_order = $event.target.value
                      }
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group m-form__group row" }, [
                _c("div", { staticClass: "col-lg-5" }, [
                  _c("label", { attrs: { for: "identification_number" } }, [
                    _vm._v(
                      _vm._s(
                        _vm._f("capitalize")(
                          _vm._f("translate")("identification_number")
                        )
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.person_document,
                        expression: "person_document"
                      }
                    ],
                    staticClass: "form-control m-input",
                    attrs: {
                      id: "identification_number",
                      type: "text",
                      name: "identification_number"
                    },
                    domProps: { value: _vm.person_document },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.person_document = $event.target.value
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-lg-3" },
                  [
                    _c("label", { attrs: { for: "date_start" } }, [
                      _vm._v(
                        _vm._s(
                          _vm._f("capitalize")(
                            _vm._f("translate")("start_date")
                          )
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("s-date-time-picker", {
                      attrs: {
                        id: "date_start",
                        name: "date_start",
                        options: _vm.config.start
                      },
                      on: {
                        empty: function($event) {
                          _vm.date_start = $event
                        }
                      },
                      model: {
                        value: _vm.date_start,
                        callback: function($$v) {
                          _vm.date_start = $$v
                        },
                        expression: "date_start"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-lg-3" },
                  [
                    _c("label", { attrs: { for: "date_end" } }, [
                      _vm._v(
                        _vm._s(
                          _vm._f("capitalize")(_vm._f("translate")("end_date"))
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("s-date-time-picker", {
                      attrs: {
                        id: "date_end",
                        name: "date_end",
                        options: _vm.config.end
                      },
                      on: {
                        empty: function($event) {
                          _vm.date_end = $event
                        }
                      },
                      model: {
                        value: _vm.date_end,
                        callback: function($$v) {
                          _vm.date_end = $$v
                        },
                        expression: "date_end"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-lg-1" }, [
                  _c("label", [_vm._v(" ")]),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: _vm.messageSearchTooltip,
                          expression: "messageSearchTooltip"
                        }
                      ],
                      staticClass: "btn btn-success",
                      attrs: { id: "btn-cancel" },
                      on: { click: _vm.filter }
                    },
                    [_c("i", { staticClass: "la la-search" })]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("s-datatable", {
                attrs: { config: _vm.datatable },
                scopedSlots: _vm._u([
                  {
                    key: "state",
                    fn: function(props) {
                      return _c("div", {}, [
                        _c(
                          "a",
                          {
                            on: {
                              click: function($event) {
                                return _vm.changeStatusAuthorization(
                                  props.row.id,
                                  props.row.state == 1 ? 0 : 1,
                                  props.row.person_id,
                                  props.row.identification_number,
                                  props.row.email
                                )
                              }
                            }
                          },
                          [
                            props.row.state == 1
                              ? _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip",
                                        value: _vm.messageStateTooltip,
                                        expression: "messageStateTooltip"
                                      }
                                    ],
                                    staticClass:
                                      "m-badge m-badge--success m-badge--wide"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("capitalize")(
                                          _vm._f("translate")("active")
                                        )
                                      )
                                    )
                                  ]
                                )
                              : _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip",
                                        value: _vm.messageStateTooltip,
                                        expression: "messageStateTooltip"
                                      }
                                    ],
                                    staticClass:
                                      "m-badge m-badge--danger m-badge--wide"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("capitalize")(
                                          _vm._f("translate")("inactive")
                                        )
                                      )
                                    )
                                  ]
                                )
                          ]
                        ),
                        _vm._v("\n               \n            ")
                      ])
                    }
                  },
                  {
                    key: "actions",
                    fn: function(props) {
                      return _c(
                        "div",
                        {},
                        [
                          _c(
                            "router-link",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: _vm.messageEditTooltip,
                                  expression: "messageEditTooltip"
                                }
                              ],
                              staticClass:
                                "m-portlet__nav-link btn m-btn m-btn--icon m-btn--icon-only m-btn--pill btn_edit",
                              attrs: {
                                to: {
                                  name: "editCargoStaff",
                                  params: { id: props.row.id }
                                }
                              }
                            },
                            [_c("i", { staticClass: "la la-edit" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: _vm.messageObservationTooltip,
                                  expression: "messageObservationTooltip"
                                }
                              ],
                              staticClass:
                                "m-portlet__nav-link btn m-btn m-btn--icon m-btn--icon-only m-btn--pill btn_edit",
                              attrs: {
                                id: "btn-newpermission",
                                "data-toggle": "modal",
                                "data-backdrop": "static",
                                "data-keyboard": "false",
                                "data-target": "#view_observations"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.getObservation(props.row.person_id)
                                }
                              }
                            },
                            [_c("i", { staticClass: "la la-list" })]
                          ),
                          _vm._v(" "),
                          _vm.allowTransform &&
                          props.row.state == 1 &&
                          _vm.pedestrianStatus[
                            props.row.identification_number
                          ] === 1
                            ? _c(
                                "a",
                                {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip",
                                      value: "Revertir a peatón",
                                      expression: "'Revertir a peatón'"
                                    }
                                  ],
                                  staticClass:
                                    "m-portlet__nav-link btn m-btn m-btn--icon m-btn--icon-only m-btn--pill btn_edit",
                                  on: {
                                    click: function($event) {
                                      return _vm.revertToPedestrian(
                                        props.row.identification_number
                                      )
                                    }
                                  }
                                },
                                [_c("i", { staticClass: "la la-user" })]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    }
                  }
                ])
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c(
          "s-modal",
          {
            attrs: {
              id: "view_observations",
              title: _vm._f("capitalize")(_vm._f("translate")("observations")),
              close_header: true,
              size: "modal-lg modal-dialog-centered"
            }
          },
          [
            _c(
              "div",
              { ref: "observations", attrs: { slot: "body" }, slot: "body" },
              [
                _c("section", [
                  _c(
                    "form",
                    {
                      staticClass: "m-form m-form--state",
                      attrs: { "data-vv-scope": "authorization" }
                    },
                    [
                      _c("div", { staticClass: "modal-body" }, [
                        _c("div", { staticClass: "m-portlet__body" }, [
                          _vm.observations.length > 0
                            ? _c("div", [
                                _c(
                                  "ul",
                                  _vm._l(_vm.observations, function(
                                    observation
                                  ) {
                                    return _c(
                                      "div",
                                      {
                                        staticClass:
                                          "content_observation_custom"
                                      },
                                      [
                                        _c("li", [
                                          _c("b", [
                                            _vm._v(
                                              _vm._s(
                                                observation.created_at.split(
                                                  "T"
                                                )[0]
                                              ) + ":"
                                            )
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(observation.observations)
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("hr")
                                      ]
                                    )
                                  }),
                                  0
                                )
                              ])
                            : _c("div", [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm._f("titleize")(
                                        _vm._f("translate")("no_records")
                                      )
                                    ) +
                                    "\n                  "
                                )
                              ])
                        ])
                      ])
                    ]
                  )
                ])
              ]
            )
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "m-portlet__head-icon" }, [
      _c("i", { staticClass: "flaticon-suitcase" })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-587d8550", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-587d8550","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/src/components/admin/cargo_authorization/All.vue
// module id = 638
// module chunks = 0 1 19